import type { Site } from '../types/Site';

const sites: Site[] = [
  {
    id: '5gradar',
    name: '5gradar',
    value: '5gradar',
    logo: '5gradar.png',
    label: '5G Radar',
    vanillaName: '5gradar',
    analyticsName: '5gradar',
    selligent_code: '5GR',
    url: '5gradar.com',
    ga: {
      id: 'UA-48894329-3',
      format: null,
    },
  },
  {
    id: 'advnture',
    name: 'advnture',
    value: 'advnture',
    logo: 'svg/advnture.svg',
    label: 'Advnture',
    vanillaName: 'advnture',
    analyticsName: 'advnture',
    selligent_code: 'ADV',
    url: 'advnture.com',
    ga: {
      id: 'UA-48457802-63',
      format: null,
    },
  },
  {
    id: 'androidcentral',
    name: 'androidcentral',
    value: 'ac',
    logo: 'androidcentral.png',
    label: 'Android Central',
    vanillaName: 'androidcentral',
    analyticsName: 'ac',
    url: 'androidcentral.com',
    ga: {
      id: 'UA-5727237-3',
      format: null,
    },
  },
  {
    id: 'avnetwork',
    name: 'avnetwork',
    value: 'avnetwork',
    logo: 'svg/avnetwork.svg',
    label: 'AV Network',
    vanillaName: 'avnetwork',
    analyticsName: 'avnetwork',
    selligent_code: 'AVT',
    url: 'avnetwork.com',
    ga: {
      id: 'UA-1208129-57',
      format: null,
    },
  },
  {
    id: 'bikeperfect',
    name: 'bikeperfect',
    value: 'bikeperfect',
    logo: 'svg/bikeperfect.svg',
    label: 'Bike Perfect',
    vanillaName: 'bikeperfect',
    analyticsName: 'bikeperfect',
    url: 'bikeperfect.com',
    ga: {
      id: 'UA-87763359-15',
      format: null,
    },
  },
  {
    id: 'cinemablend',
    name: 'cinemablend',
    value: 'cinemablend',
    logo: 'svg/cinemablend.svg',
    label: 'Cinemablend',
    vanillaName: 'cinemablend',
    analyticsName: 'cinemablend',
    url: 'cinemablend.com',
    ga: {
      id: 'UA-1237708-1',
      format: null,
    },
  },
  {
    id: 'cbq',
    name: 'creativebloq',
    value: 'cbq',
    logo: 'svg/cbq.svg',
    label: 'Creative Bloq',
    vanillaName: 'creativebloq',
    analyticsName: 'cbq',
    selligent_code: 'CBQ',
    url: 'creativebloq.com',
    ga: {
      id: 'UA-48905440-1',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.creativebloq.com',
      live: 'https://hawk.creativebloq.com',
    },
  },
  {
    id: 'cn',
    name: 'cyclingnews',
    value: 'cyclingnews',
    logo: 'cyclingnewsblack.png',
    label: 'Cycling News',
    vanillaName: 'cyclingnews',
    analyticsName: 'cyclingnews',
    selligent_code: 'CYL',
    url: 'cyclingnews.com',
    ga: {
      id: 'UA-48905626-1',
      format: null,
    },
  },
  {
    id: 'coachmag',
    name: 'coachmag',
    value: 'coachmag',
    logo: 'coachmag.png',
    label: 'Coach',
    alias: 'coachmag',
    vanillaName: 'coachmag',
    analyticsName: 'coachmag',
    url: 'coachweb.com',
    ga: {
      id: 'UA-4608194-1',
      format: null,
    },
  },
  {
    id: 'dcw',
    name: 'digitalcameraworld',
    value: 'dcw',
    logo: 'digitalcameraworld.png',
    label: 'Digital Camera World',
    vanillaName: 'digitalcameraworld',
    analyticsName: 'dcw',
    selligent_code: 'DCM',
    url: 'digitalcameraworld.com',
    ga: {
      id: 'UA-48457802-35',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.digitalcameraworld.com',
      live: 'https://hawk.digitalcameraworld.com',
    },
  },
  {
    id: 'fourfourtwo',
    name: 'fourfourtwo',
    value: 'fourfourtwo',
    logo: 'svg/fourfourtwo.svg',
    label: 'Four Four Two',
    vanillaName: 'fourfourtwo',
    analyticsName: 'fourfourtwo',
    selligent_code: 'FFT',
    url: 'fourfourtwo.com',
    ga: {
      id: 'UA-19571072-1',
      format: null,
    },
  },
  {
    id: 'getprice',
    name: 'getprice',
    value: 'getprice',
    logo: 'svg/getprice.svg',
    label: 'GetPrice AU',
    vanillaName: 'getprice',
    analyticsName: 'getprice',
    url: 'getprice.com.au',
    ga: {
      id: 'UA-833710-11',
      format: 'getprice',
    },
  },
  {
    id: 'grd',
    name: 'gamesradar',
    value: 'grd',
    logo: 'svg/gamesradar.svg',
    label: 'Gamesradar',
    vanillaName: 'gamesradar',
    analyticsName: 'grd',
    selligent_code: 'GAM',
    url: 'gamesradar.com',
    ga: {
      id: 'UA-48899774-1',
      format: null,
    },
  },
  {
    id: 'guitarplayer',
    name: 'guitarplayer',
    value: 'guitarplayer',
    logo: 'svg/guitarplayer.svg',
    label: 'Guitar World',
    vanillaName: 'guitarplayer',
    analyticsName: 'guitarplayer',
    selligent_code: 'GUP',
    url: 'guitarplayer.com',
    ga: {
      id: 'UA-2342357-1',
      format: null,
    },
  },
  {
    id: 'guitarworld',
    name: 'guitarworld',
    value: 'guitarworld',
    logo: 'svg/guitarworld.svg',
    label: 'Guitar World',
    vanillaName: 'guitarworld',
    analyticsName: 'guitarworld',
    selligent_code: 'GUW',
    url: 'guitarworld.com',
    ga: {
      id: 'UA-6661635-1',
      format: null,
    },
  },
  {
    id: 'homebuilding',
    name: 'homebuilding',
    value: 'homebuilding',
    logo: 'svg/homebuilding.svg',
    label: 'Home Building',
    analyticsName: 'homebuilding',
    vanillaName: 'homebuilding',
    selligent_code: 'HBR',
    url: 'homebuilding.co.uk',
    ga: {
      id: 'UA-1555272-7',
      format: null,
    },
  },
  {
    id: 'imore',
    name: 'imore',
    value: 'im',
    logo: 'imore.png',
    label: 'IMore',
    vanillaName: 'imore',
    analyticsName: 'imore',
    url: 'imore.com',
    ga: {
      id: 'UA-2017486-7',
      format: null,
    },
  },
  {
    id: 'itpro',
    name: 'itpro',
    value: 'itpro',
    logo: 'svg/itpro.svg',
    label: 'ITpro',
    vanillaName: 'itpro',
    analyticsName: 'itpro',
    url: 'itpro.co', // itpro.com & itpro.co.uk share this site config for just fie-widgets
    ga: {
      id: 'UA-1011119-1',
      format: null,
    },
  },
  {
    id: 'itproportal',
    name: 'itproportal',
    value: 'itproportal',
    logo: 'itproportal.png',
    label: 'IT Pro Portal',
    vanillaName: 'itproportal',
    analyticsName: 'itproportal',
    selligent_code: 'ITPP',
    url: 'itproportal.com',
    ga: {
      id: 'UA-460866-1',
      format: null,
    },
  },
  {
    id: 'ltm',
    name: 'laptopmag',
    value: 'laptopmag',
    logo: 'svg/laptopmag.svg',
    label: 'Laptop Mag',
    vanillaName: 'laptopmag',
    analyticsName: 'laptopmag',
    selligent_code: 'LTP',
    url: 'laptopmag.com',
    ga: {
      id: 'UA-72111741-6',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.laptopmag.com',
      live: 'https://hawk.laptopmag.com',
    },
  },
  {
    id: 'livescience',
    name: 'livescience',
    value: 'livescience',
    logo: 'svg/livescience.svg',
    label: 'Live Science',
    vanillaName: 'livescience',
    analyticsName: 'livescience',
    selligent_code: 'LVS',
    url: 'livescience.com',
    ga: {
      id: 'UA-72111741-7',
      format: null,
    },
  },
  {
    id: 'loudersound',
    name: 'loudersound',
    value: 'loudersound',
    logo: 'svg/loudersound.svg',
    label: 'Louder Sound',
    vanillaName: 'loudersound',
    analyticsName: 'loudersound',
    selligent_code: 'LOU',
    url: 'loudersound.com',
    ga: {
      id: 'UA-49681863-18',
      format: null,
    },
  },
  {
    id: 'mrd',
    name: 'musicradar',
    value: 'mrd',
    logo: 'svg/musicradar.svg',
    label: 'Musicradar',
    vanillaName: 'musicradar',
    analyticsName: 'mrd',
    selligent_code: 'MUR',
    url: 'musicradar.com',
    ga: {
      id: 'UA-48903850-1',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.musicradar.com',
      live: 'https://hawk.musicradar.com',
    },
  },
  {
    id: 'nexttv',
    name: 'nexttv',
    value: 'nexttv',
    logo: 'svg/nexttv.svg',
    label: 'NextTV',
    vanillaName: 'nexttv',
    analyticsName: 'nexttv',
    selligent_code: 'NXT',
    url: 'nexttv.com',
    ga: {
      id: 'UA-92042047-2',
      format: null,
    },
  },
  {
    id: 'pcg',
    name: 'pcgamer',
    value: 'pcg',
    logo: 'pcgamer.jpg',
    label: 'PC Gamer',
    vanillaName: 'pcgamer',
    analyticsName: 'pcg',
    selligent_code: 'PCG',
    url: 'pcgamer.com',
    endpoints: {
      stage: 'https://stage.hawky.pcgamer.com',
      live: 'https://hawky.pcgamer.com',
    },
    ga: {
      id: 'UA-48457802-19',
      format: null,
    },
  },
  {
    id: 'petsradar',
    name: 'petsradar',
    value: 'petsradar',
    logo: 'svg/petsradar.svg',
    label: 'Pets Radar',
    vanillaName: 'petsradar',
    analyticsName: 'petsradar',
    url: 'petsradar.com',
    ga: {
      id: 'UA-48457802-65',
      format: null,
    },
  },
  {
    id: 'space',
    name: 'space',
    value: 'space',
    logo: 'space.png',
    label: 'Space',
    vanillaName: 'space',
    analyticsName: 'space',
    selligent_code: 'SDC',
    url: 'space.com',
    ga: {
      id: 'UA-72111741-9',
      format: null,
    },
  },
  {
    id: 'techlearning',
    name: 'techlearning',
    value: 'techlearning',
    logo: 'svg/techlearning.svg',
    label: 'Tech Learning',
    vanillaName: 'techlearning',
    analyticsName: 'techlearning',
    selligent_code: 'TEL',
    url: 'techlearning.com',
    ga: {
      id: 'UA-1208129-2',
      format: null,
    },
  },
  {
    id: 'techlearninguniversity',
    name: 'techlearninguniversity',
    value: 'techlearninguniversity',
    logo: 'svg/techlearninguniversity.svg',
    label: 'Tech Learning University',
    vanillaName: 'techlearninguniversity',
    analyticsName: 'techlearninguniversity',
    selligent_code: 'TLU',
    url: 'techlearninguniversity.com',
    ga: {
      id: 'UA-92068204-2',
      format: null,
    },
  },
  {
    id: 'theradar',
    name: 'theradar',
    value: 'theradar',
    logo: 'svg/theradar.svg',
    label: 'The Radar',
    vanillaName: 'theradar',
    analyticsName: 'theradar',
    url: 'theradar.com',
    ga: {
      id: 'UA-48457802-60',
      format: null,
    },
  },
  {
    id: 'tg',
    name: 'tomsguide',
    value: 'tomsguide',
    logo: 'svg/tomsguide.svg',
    label: 'Toms Guide',
    vanillaName: 'tomsguide',
    analyticsName: 'tomsguide',
    selligent_code: 'TSG',
    url: 'tomsguide.com',
    ga: {
      id: 'UA-72111741-10',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.tomsguide.com',
      live: 'https://hawk.tomsguide.com',
    },
  },
  {
    id: 'th',
    name: 'tomshardware',
    value: 'tomshardware',
    logo: 'tomshardware.png',
    label: 'Toms Hardware',
    vanillaName: 'tomshardware',
    analyticsName: 'tomshardware',
    selligent_code: 'TSH',
    url: 'tomshardware.com',
    ga: {
      id: 'UA-72111741-12',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.tomshardware.com',
      live: 'https://hawk.tomshardware.com',
    },
  },
  {
    id: 'ttr',
    name: 'toptenreviews',
    value: 'toptenreviews',
    logo: 'svg/toptenreviews.svg',
    label: 'Top Ten Reviews',
    vanillaName: 'toptenreviews',
    analyticsName: 'toptenreviews',
    selligent_code: 'TTR',
    url: 'toptenreviews.com',
    ga: {
      id: 'UA-72111741-22',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.toptenreviews.com',
      live: 'https://hawk.toptenreviews.com',
    },
  },
  {
    id: 'trd',
    name: 'techradar',
    value: 'trd',
    logo: 'svg/techradar.svg',
    label: 'Techradar',
    vanillaName: 'techradar',
    analyticsName: 'trd',
    selligent_code: 'TCR',
    url: 'techradar.com',
    ga: {
      id: 'UA-48894329-1',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.techradar.com',
      live: 'https://hawk.techradar.com',
    },
  },
  {
    id: 'tvtechnology',
    name: 'tvtechnology',
    value: 'tvtechnology',
    logo: 'tvtechnology.png',
    label: 'TV Technology',
    vanillaName: 'tvtechnology',
    analyticsName: 'tvtechnology',
    selligent_code: 'TVT',
    url: 'tvtechnology.com',
    ga: {
      id: 'UA-2342357-10',
      format: null,
    },
  },
  {
    id: 'whathifi',
    name: 'whathifi',
    value: 'whathifi',
    logo: 'svg/whathifi.svg',
    label: 'What Hi Fi',
    vanillaName: 'whathifi',
    analyticsName: 'whathifi',
    selligent_code: 'WHI',
    url: 'whathifi.com',
    ga: {
      id: 'UA-903754-4',
      format: null,
    },
    endpoints: {
      stage: 'https://stage.hawk.whathifi.com',
      live: 'https://hawk.whathifi.com',
    },
  },
  {
    id: 'whattowatch',
    name: 'whattowatch',
    value: 'whattowatch',
    logo: 'svg/whattowatch.svg',
    label: 'What to watch',
    vanillaName: 'whattowatch',
    analyticsName: 'whattowatch',
    selligent_code: 'W2W',
    url: 'whattowatch.com',
    ga: {
      id: 'UA-48457802-64',
      format: null,
    },
  },
  {
    id: 'windowscentral',
    name: 'windowscentral',
    value: 'wp',
    logo: 'windowscentral.png',
    label: 'Windows Central',
    vanillaName: 'windowscentral',
    analyticsName: 'wp',
    url: 'windowscentral.com',
    ga: {
      id: 'UA-1058506-1',
      format: null,
    },
  },
];
export default sites;
